import { render, staticRenderFns } from "./ClientGroupAndName.vue?vue&type=template&id=49b5cee8&scoped=true"
import script from "./ClientGroupAndName.vue?vue&type=script&lang=js"
export * from "./ClientGroupAndName.vue?vue&type=script&lang=js"
import style0 from "./ClientGroupAndName.vue?vue&type=style&index=0&id=49b5cee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b5cee8",
  null
  
)

export default component.exports